"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    "hash": "917c330",
    "raw": "v2.13.0",
    "semverString": "2.13.0"
};
//# sourceMappingURL=version.js.map